export enum ProvidersPageName {
    WorkWithCoach = 'work-with-a-coach',
    WorkWithMentalHealthCoach = 'work-with-a-mental-health-coach',
    ChooseYourChoach = 'choose-your-coach',
    ChooseYourMentalHealthCoach = 'choose-your-mental-health-coach',
}
